<div id="add-new-lead-button" class="tw-ml-1">
  <button
    mat-stroked-button
    (click)="openDialog()"
    data-cy="addLeadButton"
    class="tw-bg-white">
    <mat-icon>add</mat-icon> New Merchant
  </button>
</div>
